import React, { FC } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';

import { LoadPanel } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import {
  useChangeNomenclatureTransferMutation,
  useGetNomenclatureTransferDetailQuery,
} from 'bus/nomenclatureTransfer/services';
import { NomenclatureTransfer } from 'bus/nomenclatureTransfer/types';

import { NomenclatureTransferDetailPage } from '../components/NomenclatureTransferDetailPage';

export const NomenclatureTransferDetailScreen: FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data: dataNomenclatureTransfer, isLoading } = useGetNomenclatureTransferDetailQuery({ id });
  const [createNomenclatureTransfer, { isLoading: isLoadingSubmit }] = useChangeNomenclatureTransferMutation();

  const handleSubmit = (form: NomenclatureTransfer) => {
    createNomenclatureTransfer(form).then((data) => {
      if (isSuccess(data)) {
        toast.success('Запись успешно обновлена', {
          position: 'bottom-right',
        });
      }
    });
  };

  if (!dataNomenclatureTransfer || isLoading) {
    return <LoadPanel />;
  }

  return (
    <div>
      <NomenclatureTransferDetailPage
        dataNomenclatureTransfer={dataNomenclatureTransfer}
        isLoadingSubmit={isLoadingSubmit}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
